var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.264,
    height: 17.472,
    viewBox: "0 0 17.264 17.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26494",
    "data-name": "Group 26494",
    transform: "translate(-377.559 -68.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_151859",
    "data-name": 151859,
    transform: "translate(384.559 68.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18219",
    "data-name": "Group 18219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9872",
    "data-name": "Path 9872",
    d: "M104.929,8.74,111.465,2.2a.958.958,0,0,0,0-1.351l-.573-.572a.957.957,0,0,0-1.352,0l-7.782,7.782a.965.965,0,0,0,0,1.356l7.775,7.775a.957.957,0,0,0,1.352,0l.573-.572a.957.957,0,0,0,0-1.352Z",
    transform: "translate(-101.48 0)",
    fill: "#a5a5a5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_151859-2",
    "data-name": 151859,
    transform: "translate(387.823 86) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18219-2",
    "data-name": "Group 18219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9872-2",
    "data-name": "Path 9872",
    d: "M104.929,8.74,111.465,2.2a.958.958,0,0,0,0-1.351l-.573-.572a.957.957,0,0,0-1.352,0l-7.782,7.782a.965.965,0,0,0,0,1.356l7.775,7.775a.957.957,0,0,0,1.352,0l.573-.572a.957.957,0,0,0,0-1.352Z",
    transform: "translate(-101.48 0)",
    fill: "#a5a5a5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9868bf6d1dda41ad4cc6818db111da5d.svg";
export { ForwardRef as ReactComponent };